import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BranchService {

  private moduleName: string = "Branch";
  searchDetails: any = {};
  private searchSource = new BehaviorSubject(this.searchDetails);

  private _selectedBranch = new BehaviorSubject("");

  private tourmindId = new BehaviorSubject(0);

  currentSearch = this.searchSource.asObservable();
  url = environment.endpoint + "/api/" + this.moduleName;

  constructor(
    private http: HttpClient,
  ) {
  }

  getHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      })
    };
  }

  getSelectedBranch(){
    return this._selectedBranch;
  }
  
  setSelectedBranch(selectedBranch : any){
    return this._selectedBranch.next(JSON.stringify(selectedBranch));
  }

  getStoredTourmindId(){
    return this.tourmindId;
  }

  isTourmindId (tourmindId) : boolean {
    return tourmindId != null &&
    !Number.isNaN(tourmindId) &&
    tourmindId != 0 &&
    tourmindId != '0'
  }

  setStoredTourmindId(tourmindId : any){
    return this.tourmindId.next(parseInt(tourmindId));
  }

  get(id:any) {
    console.log('get branch')
    const url = this.url + "/" + (id != undefined ? id : '');
    return this.http.get(url, this.getHeaders());
  }
  getAll() {
    const url = this.url
    return this.http.get(url, this.getHeaders());
  }
  getList() {
    const url = this.url + '/list';
    return this.http.get(url, this.getHeaders());
  }

  create(info: any) {
    const url = this.url + '/create';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  handleError(error: HttpErrorResponse) {
    console.log(error);
    return throwError(error);
  }
 

  update(info: { id: string; }) {
    const url = this.url + '/' + info.id;
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }
 

  updateThumbnail(info) {
    const url = this.url + '/thumbnail';
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  delete(info: { id: string; }) {
    const url = this.url + '/' + info.id;
    return this.http.delete(url, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  getAmenity(id:any) {
    const url = this.url + "/amenity/" + (id != undefined ? id : '');
    return this.http.get(url);
  }

  getAmenitybyBranchId(id: string) {
    const url = this.url + "/amenity/BranchId=" + id;
    return this.http.get(url);
  } 

  createAmenity(info: any) {
    const url = this.url + '/amenity' + '/create';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  updateAmenity(info: { id: string; }) {
    const url = this.url + '/amenity' + '/' + info.id;
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  deleteAmenity(info: { id: string; }) {
    const url = this.url + '/amenity' + '/' + info.id;
    return this.http.delete(url, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  suspend(id: string) {
    const url = this.url + '/suspend' + '/' + id;
    return this.http.put(url, {}, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }
  unsuspend(id: string) {
    const url = this.url + '/unsuspend' + '/' + id;
    return this.http.put(url, {}, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }
}